import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import makeValidationSchema from './GoodsInfoMakeValidationSchema'

const {
  form: {
    field: {
      CngTextField,
      CngCodeMasterAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: null,
  billNo: "",
  parentBillNo: "",
  containerNumber: "",
  goodsItemNumber: "",
  totalPackageQuantity: "",
  packageTypeDescription: "",
  goodsItemGrossWeight: "",
  grossWeightUnitCode: "",
  hsCode: "",
  goodsItemDescription: "",
  additionalInfo: "",
  packageType: "",
  packingDescription: "",
  handlingInstructionCode: "",
  handlingInstructionDesc: "",
  goodsItemNetWeight: "",
  netWeightUnitCode: "",
  volume: "",
  volumeUnitCode: "",
  packingInstructionsCode: "",
  marksAndLabels: "",
  countryOfOrigin: "",
  locationName: "",
  dgHazardClassCodes: "",
  undgIdentifier: "",
  dgFlashpointDesc: "",
  shipmentFlashpointDegree: "",
  flashpointUnitCode: "",
  packagingDangerLevelCode: "",
  doesPackageToBeSplit: ""
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, documentType }) {
  const { setValue } = useFormContext()
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const t = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let containerNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.CONTAINER_NUMBER)
    let goodsItemNumber = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GOODS_ITEM_NUMBER)
    let totalPackageQuantity = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.TOTAL_PACKAGE_QUANTITY)
    let packageTypeDescription = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.PACKAGE_TYPE_DESCRIPTION)
    let goodsItemGrossWeight = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GOODS_ITEM_GROSS_WEIGHT)
    let grossWeightUnitCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GROSS_WEIGHT_UNIT_CODE)
    let hsCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.HS_CODE)
    let goodsItemDescription = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GOODS_ITEM_DESCRIPTION)
    let additionalInfo = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.ADDITIONAL_INFO)
    let packageType = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.PACKAGE_TYPE)
    let packingDescription = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.PACKING_DESCRIPTION)
    let handlingInstructionCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.HANDLING_INSTRUCTION_CODE)
    let handlingInstructionDesc = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.HANDLING_INSTRUCTION_DESC)
    let goodsItemNetWeight = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.GOODS_ITEM_NET_WEIGHT)
    let netWeightUnitCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.NET_WEIGHT_UNIT_CODE)
    let volume = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.VOLUME)
    let volumeUnitCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.VOLUME_UNIT_CODE)
    let packingInstructionsCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.PACKING_INSTRUCTIONS_CODE)
    let marksAndLabels = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.MARKS_AND_LABELS)
    let countryOfOrigin = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.COUNTRY_OF_ORIGIN)
    let locationName = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.LOCATION_NAME)
    let dgHazardClassCodes = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.DG_HAZARD_CLASS_CODES)
    let undgIdentifier = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.UNDG_IDENTIFIER)
    let dgFlashpointDesc = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.DG_FLASHPOINT_DESC)
    let shipmentFlashpointDegree = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.SHIPMENT_FLASHPOINT_DEGREE)
    let flashpointUnitCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.FLASHPOINT_UNIT_CODE)
    let packagingDangerLevelCode = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.PACKAGING_DANGER_LEVEL_CODE)
    let doesPackageToBeSplit = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.DOES_PACKAGE_TO_BE_SPLIT)

    return {
      containerNumber, goodsItemNumber, totalPackageQuantity, packageTypeDescription,
      goodsItemGrossWeight, grossWeightUnitCode, hsCode, goodsItemDescription,
      additionalInfo, packageType, packingDescription, handlingInstructionCode,
      handlingInstructionDesc, goodsItemNetWeight, netWeightUnitCode, volume,
      volumeUnitCode, packingInstructionsCode, marksAndLabels, countryOfOrigin,
      locationName, dgHazardClassCodes, undgIdentifier, dgFlashpointDesc,
      shipmentFlashpointDegree, flashpointUnitCode, packagingDangerLevelCode,
      doesPackageToBeSplit
    }
  }

  return (
    <Grid container spacing={1}>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required
          name="containerNumber"
          label={t.containerNumber}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 17 }}
          onChange={(e) => setValue("containerNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required
          name="goodsItemNumber"
          label={t.goodsItemNumber}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 6 }}
          onChange={(e) => setValue("goodsItemNumber", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required
          name="totalPackageQuantity"
          label={t.totalPackageQuantity}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 8 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required
          name="packageTypeDescription"
          label={t.packageTypeDescription}
          disabled={disabled}
          codeType='UAE_MPCI_PACKAGE_TYPE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required
          name="goodsItemGrossWeight"
          label={t.goodsItemGrossWeight}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 18 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required
          name="grossWeightUnitCode"
          label={t.grossWeightUnitCode}
          disabled={disabled}
          codeType='UAE_MPCI_WEIGHT_UOM'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          required={documentType === '705'}
          name="hsCode"
          label={t.hsCode}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 18 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={12} lg={8}>
        <CngTextField
          required={documentType === '705'}
          name="goodsItemDescription"
          label={t.goodsItemDescription}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 2560 }}
          multiline
          rows={2}
          onChange={(e) => setValue("goodsItemDescription", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="additionalInfo"
          label={t.additionalInfo}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 512 }}
          onChange={(e) => setValue("additionalInfo", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="packageType"
          label={t.packageType}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 35 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="packingDescription"
          label={t.packingDescription}
          disabled={disabled}
          codeType='UAE_MPCI_PACKING_DESC'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="handlingInstructionCode"
          label={t.handlingInstructionCode}
          disabled={disabled}
          codeType='UAE_MPCI_HANDLING_INSTRUCTION'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="handlingInstructionDesc"
          label={t.handlingInstructionDesc}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 512 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="goodsItemNetWeight"
          label={t.goodsItemNetWeight}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 18 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="netWeightUnitCode"
          label={t.netWeightUnitCode}
          disabled={disabled}
          codeType='UAE_MPCI_WEIGHT_UOM'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="volume"
          label={t.volume}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 18 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="volumeUnitCode"
          label={t.volumeUnitCode}
          disabled={disabled}
          codeType='UAE_MPCI_VOLUME_UOM'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="packingInstructionsCode"
          label={t.packingInstructionsCode}
          disabled={disabled}
          codeType='UAE_MPCI_PACKING_INSTRUCTIONS'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="marksAndLabels"
          label={t.marksAndLabels}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 35 }}
          onChange={(e) => setValue("marksAndLabels", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="countryOfOrigin"
          label={t.countryOfOrigin}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 2 }}
          onChange={(e) => setValue("countryOfOrigin", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="locationName"
          label={t.locationName}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 256 }}
          onChange={(e) => setValue("locationName", e.target.value.toUpperCase(), { shouldValidate: true })}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="dgHazardClassCodes"
          label={t.dgHazardClassCodes}
          disabled={disabled}
          codeType='UAE_MPCI_IMDG_CODE'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="undgIdentifier"
          label={t.undgIdentifier}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 4 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="dgFlashpointDesc"
          label={t.dgFlashpointDesc}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 8 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngTextField
          name="shipmentFlashpointDegree"
          label={t.shipmentFlashpointDegree}
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 3 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="flashpointUnitCode"
          label={t.flashpointUnitCode}
          disabled={disabled}
          codeType='UAE_MPCI_TEMP_MEASUREMENT'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          name="packagingDangerLevelCode"
          label={t.packagingDangerLevelCode}
          disabled={disabled}
          codeType='UAE_MPCI_DANGER_LEVEL'
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} lg={4}>
        <CngCodeMasterAutocompleteField
          required
          name="doesPackageToBeSplit"
          label={t.doesPackageToBeSplit}
          disabled={disabled}
          codeType='UAE_MPCI_YES_NO'
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default FormProperties
